<!-- is-select.component.html -->
<ng-container *ngIf="DataSource$ | async as DataSource">
  <!-- Before Selecting -->
  <div
    *ngIf="selectionModel.selected.length == 0"
    class="position-relative"
    [class.input-suffix]="DataSource.columns[1]?.suffix"
    [attr.suffix]="DataSource.columns[1]?.suffix"
  >
    <ng-container *ngIf="!noSearchInput; else selectOnlyTemplate"> 
      <input
        #search
        type="text"
        autocomplete="off"
        class="form-control position-relative is-select-input"
        [class.form-control-solid]="solid"
        [formControl]="searchFilter"
        [ngClass]="{
          'valid-input-border': valid,
          'invalid-input-border': invalid,
          'form-control-sm': smallInput
        }"
        [placeholder]="placeholder"
        [id]="'input_' + componentId"
        [matMenuTriggerFor]="menu"
        (menuOpened)="inputFocus()"
        [disabled]="disabled"
      />
    </ng-container>
    <ng-template #selectOnlyTemplate>
      <div class="form-control position-relative is-select-input" 
        #search
        [ngClass]="{
          'valid-input-border': valid,
          'invalid-input-border': invalid,
          'form-control-sm': smallInput,
          'form-control-solid': solid
        }"
        [id]="'input_' + componentId"
        [matMenuTriggerFor]="menu"
        (menuOpened)="inputFocus()"
      ></div>
    </ng-template>
    <!-- Loading indicator -->
    <div class="position-absolute input-loader mx-1 pt-1" *ngIf="(isLoading || showPartialLoader) && !matMenuTrigger.menuOpen">
      <div class="position-relative">
        <ngx-spinner
          [name]="selectKey!"
          class="spinner"
          bdColor="rgba(255,255,255,0)"
          [size]="smallInput ? 'small' : 'default'"
          color="var(--kt-input-solid-color)"
          type="ball-pulse"
          [fullScreen]="false"
        ></ngx-spinner>
      </div>
    </div>
  </div>

  <!-- After Selecting (with codeBTN) -->
  <div *ngIf="selectionModel.selected.length > 0 && DataSource.codeBTN" class="input-group" [ngClass]="{ 'input-group-sm': smallInput }">
    <span
      class="input-group-text bg-secondary codeBTN"
      (click)="openDialog()"
      *ngIf="DataSource.codeBTN"
      [ngClass]="{
        'valid-input-no-right-border': valid,
        'invalid-input-no-right-border': invalid,
        'form-control-sm': smallInput
      }"
    >
      {{ selectionModel.selected[0][DataSource.codeBtnId ?? DataSource.columns[0].identifier] }}
    </span>

    <input
      type="text"
      class="form-control position-relative is-select-input"
      autocomplete="off"
      [class.rounded-end-0]="!disabled"
      [class.form-control-solid]="solid"
      readonly
      [id]="'input_' + componentId"
      [attr.disabled]="disabled ? disabled : null"
      [ngClass]="{
        'valid-input-no-right-border': valid,
        'invalid-input-no-right-border': invalid,
        'form-control-sm': smallInput
      }"
      [matMenuTriggerFor]="menu"
      (menuOpened)="inputFocus()"
      [value]="translateData ? (selectionModel.selected[0][DataSource.columns[1].identifier]?.toString() | translate) : (selectionModel.selected[0][DataSource.columns[1].identifier]?.toString())"
    />

    <span class="input-group-text no-border" *ngIf="DataSource.columns[1]?.suffix" [class.disabled-input]="disabled ? disabled : null">
      {{ DataSource.columns[1].suffix }}
    </span>

    <!-- Loading indicator -->
    <div class="position-absolute input-loader mx-1 pt-1" *ngIf="(isLoading || showPartialLoader) && !matMenuTrigger.menuOpen">
      <div class="position-relative">
        <ngx-spinner
          [name]="selectKey!"
          class="spinner"
          bdColor="rgba(255,255,255,0)"
          [size]="smallInput ? 'small' : 'default'"
          color="var(--kt-input-solid-color)"
          type="ball-pulse"
          [fullScreen]="false"
        ></ngx-spinner>
      </div>
    </div>

    <!-- Eye button -->
    <button
      *ngIf="!disabled && showViewButton"
      class="btn btn-secondary btn-icon h-auto"
      type="button"
      (click)="emitViewSelected($event)"
      [ngClass]="{ 'btn-sm': smallInput }"
      matTooltip="{{ 'lib.VIEW' | translate }}"
      matTooltipPosition="above"
    >
      <i class="fa-solid fa-eye"></i>
    </button>

    <!-- Clear input -->
    <button
      *ngIf="!disabled"
      (click)="deselect()"
      class="btn btn-secondary btn-icon h-auto"
      type="button"
      [ngClass]="{
        'btn-sm': smallInput,
        'valid-input-no-left-border': valid,
        'invalid-input-no-left-border': invalid
      }"
    >
      <i class="fa fa-xmark x-mark"></i>
    </button>
  </div>

  <!-- After Selecting (without codeBTN) -->
  <div *ngIf="selectionModel.selected.length > 0 && !DataSource.codeBTN" class="input-group" [ngClass]="{ 'input-group-sm': smallInput }">
    <div class="input-select" [attr.suffix]="DataSource.columns[1]?.suffix" [class.input-suffix]="DataSource.columns[1]?.suffix">
      <input
        type="text"
        class="form-control position-relative is-select-input"
        autocomplete="off"
        [class.rounded-end-0]="!disabled"
        [class.form-control-solid]="solid"
        readonly
        [id]="'input_' + componentId"
        [attr.disabled]="disabled ? disabled : null"
        [ngClass]="{
          'valid-input-no-right-border': valid,
          'invalid-input-no-right-border': invalid,
          'form-control-sm': smallInput
        }"
        [matMenuTriggerFor]="menu"
        (menuOpened)="inputFocus()"
        [value]="translateData ? (selectionModel.selected[0][DataSource.columns[1].identifier]?.toString() | translate) : (selectionModel.selected[0][DataSource.columns[1].identifier]?.toString())"
      />

      <!-- Loading indicator -->
      <div class="position-absolute input-loader mx-1 pt-1" *ngIf="(isLoading || showPartialLoader) && !matMenuTrigger.menuOpen">
        <ngx-spinner
          [name]="selectKey!"
          class="table-spinners"
          bdColor="rgba(255,255,255,0)"
          [size]="smallInput ? 'small' : 'default'"
          color="var(--kt-input-group-addon-color)"
          type="ball-pulse"
          [fullScreen]="false"
        ></ngx-spinner>
      </div>
    </div>

    <button
      *ngIf="!disabled && showViewButton"
      class="btn btn-secondary btn-icon h-auto"
      type="button"
      (click)="emitViewSelected($event)"
      [ngClass]="{ 'btn-sm': smallInput }"
      matTooltip="{{ 'lib.VIEW' | translate }}"
      matTooltipPosition="above"
    >
      <i class="fa-solid fa-eye"></i>
    </button>

    <!-- Clear input -->
    <button
      *ngIf="!disabled"
      (click)="deselect()"
      class="btn btn-secondary btn-icon h-auto"
      type="button"
      [ngClass]="{
        'btn-sm': smallInput,
        'valid-input-no-left-border': valid,
        'invalid-input-no-left-border': invalid
      }"
    >
      <i class="fa fa-xmark x-mark"></i>
    </button>
  </div>
</ng-container>

<!-- Menu -->
<mat-menu #menu="matMenu" panelClass="is-select-panel" class="min-w-250px" [overlapTrigger]="false">
  <ng-container *ngIf="menuTemplate != null">
    <ng-container *ngTemplateOutlet="menuTemplate"></ng-container>
  </ng-container>

  <ng-container *ngIf="menuTemplate == null">
    <ng-container *ngIf="DataSource$ | async as DataSource">
      <div class="is-select-menu" [id]="'menu_' + componentId" (click)="$event.stopPropagation();">
        <!-- ✅ scroll is here (the element that actually has overflow-y:auto in CSS) -->
        <div class="is-select-list" (scroll)="scrollHandler($event)">

          <!-- Loader -->
          <div class="is-select-loader" *ngIf="isLoading">
            <ngx-spinner
              [name]="selectKey!"
              class="spinner"
              bdColor="rgba(255,255,255,0)"
              [size]="smallInput ? 'small' : 'default'"
              color="var(--kt-input-solid-color)"
              type="ball-pulse"
              [fullScreen]="false"
            ></ngx-spinner>
          </div>

          <!-- Items -->
          <ng-container *ngIf="!isLoading">
            <ng-container *ngFor="let item of DataSource.body">
              <button
                type="button"
                class="is-select-item"
                [class.is-selected]="selectionModel.isSelected(item)"
                (click)="onSelect(item)"
              >
                <!-- avatar (optional) -->
                <ng-container *ngIf="showAvatar; else noAvatar">
                  <ng-container *ngIf="getAvatarSrc(item) as src; else fallbackInitials">
                    <img class="is-avatar" [src]="src" alt="avatar" />
                  </ng-container>

                  <ng-template #fallbackInitials>
                    <div class="is-avatar is-avatar-fallback">
                      {{ initials(translateData ? ((item[DataSource.columns[1].identifier]?.toString() | translate) ?? '') : (item[DataSource.columns[1].identifier]?.toString() ?? '')) }}
                    </div>
                  </ng-template>
                </ng-container>

                <ng-template #noAvatar>
                  <ng-container></ng-container>
                </ng-template>

                <!-- icon (optional) -->
                <i *ngIf="DataSource.columns[2]" class="fas me-2 is-item-icon" [ngClass]="'fa-fw fa-' + item[DataSource.columns[2].identifier]"></i>

                <!-- label -->
                <span
                  #lbl
                  class="is-item-label"
                  [matTooltip]="translateData ? (item[DataSource.columns[1].identifier]?.toString() | translate) : (item[DataSource.columns[1].identifier]?.toString())"
                  [matTooltipDisabled]="!isTruncated(lbl)"
                  matTooltipPosition="right"
                >
                  <ng-container *ngIf="translateData">
                    <span
                      [class.text-dark]="item.isActive === null || item.isActive === undefined"
                      [class.text-danger]="item.isActive === false"
                      [class.text-success]="item.isActive === true"
                    >
                      {{ item[DataSource.columns[1].identifier]?.toString() | translate }}
                    </span>
                  </ng-container>
                  <ng-container *ngIf="!translateData">
                    <span
                      [class.text-dark]="item.isActive === null || item.isActive === undefined"
                      [class.text-danger]="item.isActive === false"
                      [class.text-success]="item.isActive === true"
                    >
                      {{ item[DataSource.columns[1].identifier]?.toString() }}
                    </span>
                  </ng-container>
                </span>

                <i class="fa-solid fa-check text-success is-selected-icon" *ngIf="selectionModel.isSelected(item)"></i>
              </button>
            </ng-container>
          </ng-container>

          <!-- Partial loader -->
          <div class="is-select-loader" *ngIf="showPartialLoader">
            <ngx-spinner
              [name]="selectKey!"
              class="spinner"
              bdColor="rgba(255,255,255,0)"
              [size]="smallInput ? 'small' : 'default'"
              color="var(--kt-input-solid-color)"
              type="ball-pulse"
              [fullScreen]="false"
            ></ngx-spinner>
          </div>

          <!-- Empty -->
          <div class="is-select-empty" *ngIf="(DataSource.body?.length ?? 0) === 0 && (!isLoading || minCharsWarning)">
            <div *ngIf="!minCharsWarning">{{ 'lib.NO_RECORD_FOUND' | translate }}</div>
            <div *ngIf="minCharsWarning">{{ 'lib.INSERT_MINIMUM_CHARACTERS' | translate: { minChars: minChars } }}</div>
          </div>

        </div>
      </div>
    </ng-container>
  </ng-container>
</mat-menu>